<script lang="ts">
    import { Link } from "@inertiajs/svelte";
    import Icon from "@lernetz/svelte-icon/Icon.svelte";
    import ProgressBar from "./ProgressBar.svelte";
    import { requests, setupSharedProps, sharedProps } from "../services";
    import Image from "@lernetz/svelte-image/components/Image.svelte";
    import { getLocale } from '../utils/getLocale';

    export let course;

    const locale = getLocale();

    setupSharedProps();

    let progress = 0.4;
</script>

<Link href="/{locale}/courses/{course.id}">
    <div class="h-[320px] rounded-2xl flex transition-all duration-200 bg-light-grey hover:bg-medium-grey relative">

        <div class="absolute top-16 left-16 flex h-32 w-32 items-center justify-center rounded-full bg-white z-10">
            <span class="text-primary-dark text-18 font-bold">{course.number}</span>
        </div>
        <ProgressBar progress="{progress}" class="absolute bottom-24 left-24 right-24"></ProgressBar>
        <div class="p-24">
            <div class="flex justify-center rounded-2xl z-0">
                <Image
                        class="w-full absolute inset-0 object-cover z-0 h-128 rounded-t-2xl"
                        request={requests.assets}
                        vars={{ file_name: course.icon?.file_name, preset: "medium.png" }}
                    />
            </div>
            <div class="h-[70px] mt-96 flex items-center z-20">
                <span class="text-almost-black text-16 font-bold text-ellipsis overflow-hidden">{course.title}</span>
            </div>
        </div>
    </div>
</Link>
